import React from 'react';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import CommonAreaTableApp from './Functionality/CommonAreaTableApp';
import CustomCard from '../../../../components/CustomCard';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { getStatusNameById, STATUS_MODEL } from '../../../../enums/statusEnum';
import CustomChip from '../../../../components/CustomChip';
import { IconBuildingLocation, IconClockTable } from '../../../../components/buttons/IconButtons';
import NotInformation from '../../../../components/NotInformation';
import CustomTooltip from "../../../../components/CustomTooltip";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const CommonAreaTable = (
    {
        setBodyForExport, setSearch, setSimpleSearch,
        results, setResults,
        searchElement, setSearchElement,
        handleClickItem,
        eventDetail
    }
) => {

    const {
        t,
        tableId,
        searchId,
        pagination,
        option,
        rowsPerPage,
        elementRef
    } = CommonAreaTableApp({ results, setResults, searchElement });


    return (
        <>
            <SearchSimple
                id={searchId}
                label={"search_common_area"}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
            />
            <>
                <div className='panelTables-container custom-scrollbar' ref={elementRef}>
                    {results?.content?.length > 0
                        ?
                        <div className='row m-0 p-0'>
                            {results?.content?.map((item, index) => {
                                const noSelected = item?.statusId === STATUS_MODEL.ACTIVE_COMPANY && !eventDetail?.bookingSelected?.from;

                                return  <div
                                    key={`${tableId + '_' + (item.id || index)}`}
                                    id={`${tableId + '_' + (item.id || index)}`}
                                    className={`col-sm-12 col-md-6 m-0 p-0 mb-3 ${index % 2 === 1 ? 'pl-3' : ''} ${noSelected ? 'cursor-pointer' : ''}`}
                                    onClick={(e) => {
                                        if (noSelected) {
                                            handleClickItem(item);
                                        }
                                    }}
                                >
                                    <CustomCard
                                        classCard="card-border-8px"
                                        classContent={`background-shades-50 row ${noSelected ? 'background-hover-shades-100' : ''}`}
                                    >
                                        <div className={"p-0 m-0 col-2"}>
                                            <div
                                                className={`${noSelected
                                                    ? 'background-primary-100'
                                                    : 'background-shades-200'
                                                } d-flex align-items-center justify-content-center p-8px maxw-44px border-radius-8px`}
                                            >
                                                <IconBuildingLocation className={`${noSelected ? '' : 'icon-color-shades-500'}`}/>
                                            </div>
                                        </div>


                                        <div className={"p-0 m-0 col-10 d-flex flex-column justify-content-start gap-1 "}>
                                            <div className="d-flex justify-content-between flex-grow-1 minw-0">
                                                <div className={"flex-grow-1 minw-0"}>
                                                    <CustomTooltip
                                                        text={item?.zoneName}
                                                        classes={`mb-0 fs-12px ibl-font-w-600 text-ellipsis-1-row ${noSelected ? 'font-color-general-950' : 'font-color-shades-500'}`}
                                                        showIfTruncated={true}
                                                        placement={"top"}
                                                    />
                                                </div>

                                                <CustomChip
                                                    background={statusColor[item?.statusId]}
                                                    fontColor={statusFontColor[item?.statusId]}
                                                    borderColor={statusBorderColor[item?.statusId]}
                                                    legend={t(getStatusNameById(item?.statusId) || '')}
                                                    variant="large"
                                                />
                                            </div>

                                            <div className="d-flex align-items-center justify-content-between flex-grow-1 minw-0">
                                                <div className={"d-flex align-items-center mr-2"}>
                                                    <IconClockTable className={`${noSelected ? '' : 'icon-color-shades-400'}`}/>
                                                </div>
                                                <div className={"flex-grow-1 minw-0"}>
                                                    <CustomTooltip
                                                        text={`${t("available_from")} ${item?.from?.slice(0, 5)} ${t("to").toLowerCase()} ${item?.to?.slice(0, 5)}`}
                                                        classes={"fs-14px ibl-font-w-500 font-color-shades-500 text-ellipsis-1-row"}
                                                        showIfTruncated={true}
                                                        placement={"top"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </CustomCard>
                                </div>
                            })}
                        </div>
                        :
                        <NotInformation text={t('no_information')} className={"h-100"} card={true} />
                    }
                </div>
                <div>
                    {pagination()}
                </div>
            </>
        </>
    )

}

export default CommonAreaTable
